// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:768px){.max-w-400[data-v-2ca8af75]{max-width:40rem}[data-v-2ca8af75] .toast-modal-button{padding-bottom:2.4rem;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin-left:auto;margin-right:auto}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
